import { render, staticRenderFns } from "./FrzPalletChangeGroup.vue?vue&type=template&id=b4ce5b00"
import script from "./FrzPalletChangeGroup.vue?vue&type=script&lang=js"
export * from "./FrzPalletChangeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports